//back to this
import { useDecryptCard } from "./modules/useDecryptCard";

function DecryptCardDetaiTemplate() {
  const { cardDetails, bookingInfo } = useDecryptCard();
  return (
    <div className="container">
      <h2>Card Details</h2>

      {/* Show Booking ID and Total Amount */}
      <div className="card mt-4 mb-5">
        <div className="card-body">
          <h5 className="card-title">Booking Information</h5>
          <p>
            <strong>Booking ID:</strong> {bookingInfo.bookingId}
          </p>
          <p>
            <strong>Total Amount:</strong>{" "}
            {bookingInfo.totalamount ? `${bookingInfo.totalamount} VND` : "N/A"}
          </p>
        </div>
      </div>

      {/* Show Decrypted Card Information */}
      {cardDetails ? (
        <div className="card mt-4 mb-5">
          <div className="card-body">
            <h5 className="card-title">Card Information</h5>
            <p>
              <strong>Card Number:</strong> {cardDetails.cardNumber}
            </p>
            <p>
              <strong>Expiry Date:</strong> {cardDetails.cardExpiry}
            </p>
            <p>
              <strong>CVV:</strong> {cardDetails.cardCVC}
            </p>
          </div>
        </div>
      ) : (
        <p>Loading decrypted card details...</p>
      )}
    </div>
  );
}

export default DecryptCardDetaiTemplate;
